import React, { forwardRef, useImperativeHandle, useEffect } from 'react';
import { isNil } from '@common/utils';
import SatButton from '@components/common/satUI/SatButton';

const EaTermsAgree = forwardRef((props, ref) => {
  const {
    inputComplete,
    show3rdTelco,
    handleShowTerms,
    setCheckAgreeAll,
    checkAgree2,
    setCheckAgree2,
    btnDisabled,
    SetBtnDisabled,
  } = props;

  useEffect(() => {
    const cleanUp = () => {
      typeof setCheckAgree2 === 'function' && setCheckAgree2(false);
      typeof SetBtnDisabled === 'function' && SetBtnDisabled(true);
    };

    return cleanUp;
  }, []);

  useImperativeHandle(ref, () => ({
    clearCheck() {
      setCheckAgree2(false);
      SetBtnDisabled(true);
    },
  }));

  const handleClickTerms = targetId => {
    if ('terms2' === targetId) {
      if (checkAgree2 === false) {
        SetBtnDisabled(false);
      } else {
        !isNil(setCheckAgreeAll) &&
          'function' === typeof setCheckAgreeAll &&
          setCheckAgreeAll(false);
        SetBtnDisabled(true);
      }
      setCheckAgree2(!checkAgree2);
    }
  };

  const handleOnOk = () => {
    inputComplete();
  };

  return (
    <>
      <h3 className="layer-tit2">약관 동의</h3>
      <div className="agree-list modal-type">
        <div className="tit-area">
          <div className="check-wrap default">
            <input
              type="checkbox"
              name="checkbox2"
              id="checkbox2"
              checked={checkAgree2 ? 'checked' : ''}
              onChange={() => handleClickTerms('terms2')}
            />
            <label htmlFor="checkbox2">휴대전화 본인인증 필수 항목 동의</label>
          </div>
          <span
            className="btn-view2"
            onClick={() => handleShowTerms('terms2')}
            style={{ cursor: 'pointer' }}
          >
            전문보기
          </span>
        </div>
        <ul className="list-block">
          <li>개인정보 수집/이용 동의</li>
          <li>고유식별정보 처리 동의</li>
          <li>서비스 이용약관 동의</li>
          <li>통신사 이용약관 동의</li>
          <li style={{ visibility: show3rdTelco ? 'visible' : 'hidden' }}>
            알뜰폰 제3자 제공 동의
          </li>
        </ul>
      </div>
      <div className="btn-area">
        <SatButton
          styleClass="btn-l blue"
          label={'인증번호 받기'}
          onClick={handleOnOk}
          disabled={btnDisabled}
        />
      </div>
    </>
  );
});

export default EaTermsAgree;
